import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';
import { Heading } from '@gitbook/spine-react';

import { apiClient } from '../../../state';
import { SiteQuickActionCard, SiteQuickActionCardIcon } from '../../Site';
import type { SpaceCreationOnCreateSpace } from './types';

interface BlankCardProps {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function BlankCard(props: BlankCardProps) {
    const { organizationId, onCreateSpace } = props;
    return (
        <SiteQuickActionCard
            onPress={async () => {
                await onCreateSpace(async ({ collectionId }) => {
                    const { data: space } = await apiClient.spaces.createSpace(organizationId, {
                        parent: collectionId,
                    });
                    analytics.logEvent(
                        analytics.createSpaceEvent(space, {
                            type: 'space_create',
                            source: 'blank',
                        })
                    );
                    return space;
                });
            }}
        >
            <SiteQuickActionCardIcon>
                <Icon.Page />
            </SiteQuickActionCardIcon>
            <Heading>Start with blank</Heading>
        </SiteQuickActionCard>
    );
}
